export default {
    /**
     * {Room|null}
     */
    instance: null,
    /**
     * {array<Message>}
     */
    messages: [],
    timers: {}
}